import {Component, Inject, OnInit} from '@angular/core';
import {SendAchMailAction} from '../../achRejectModule/components/ach-reject-list/send-ach-mail.action';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AppConstants} from '../../shared/constants/app-constants';

@Component({
    selector: 'app-api-token',
    templateUrl: './api-token.component.html',
    styleUrls: ['./api-token.component.css'],
    standalone: false
})
export class ApiTokenComponent implements OnInit {

  constructor(private dialog: MatDialogRef<ApiTokenComponent>,
              dataManager: DataManagerService,
              snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: { token: string, item: any}) {
    // super();
  }

  closeAction() {
    this.dialog.close('cancel');
  }
  copy(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    const tooltip = document.getElementById('myTooltip');
    tooltip.innerHTML = 'Copied';
  }
  ngOnInit(): void {
  }
  // This component is currently empty and serves as a placeholder.
  // You can add functionality or remove it if not needed.
}
